import { Localized } from './Localized';

export default Localized;
